// How the hit count of a filter suggestion reaches the screen. Its own file
// (and not next to a same-named .tsx) so it is testable without a DOM.

// The search index counts no further than ten thousand; above that any exact
// number is a lie. The server passes this on as `capped`.
export function filterCountLabel(total?: number | null, capped?: boolean): string {
  if (total === undefined || total === null) return "";
  if (total === 0) return "geen kavels";
  const number = total.toLocaleString("nl-NL");
  if (capped) return `meer dan ${number} kavels`;
  return total === 1 ? "1 kavel" : `${number} kavels`;
}

export function filterButtonTitle(total?: number | null, capped?: boolean): string {
  if (total === 0) return "Dit filter levert geen kavels op";
  const count = filterCountLabel(total, capped);
  return count ? `Toon ${count} op de kaart` : "Toon deze kavels op de kaart";
}
